import React, { PureComponent } from 'react';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Row, Col, Input, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import styles from './style.less';
import RegionSelector from './RegionSelector';
const FormItem = Form.Item;

@Form.create()
class AccountDetails extends PureComponent {
  validAccountName = (rule, value, callback) => {
    const { form } = this.props;
    const { allCloudAccountsList } = this.props;
    if (allCloudAccountsList.length > 0) {
      if (
        allCloudAccountsList.some(
          account => account.accountName === form.getFieldValue('accountName').trim()
        )
      ) {
        return callback('This cloud account name is already taken. Please try another.');
      }
      callback();
    }
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 10 },
      wrapperCol: { span: 14 },
    };

    return (
      <div>
        <Row>
          <Col span={12}>
            <Form layout="horizontal" className={styles.stepForm} hideRequiredMark>
              <h5
                style={{
                  marginBottom: '25px',
                  color: 'black',
                }}
              >
                Name this Cloud Account
              </h5>
              <FormItem {...formItemLayout}>
                {getFieldDecorator('accountName', {
                  initialValue: this.props?.accountName || '',
                  getValueFromEvent: event => {
                    this.props.onFormValuesChange('accountName', event.target.value);
                    return event.target.value;
                  },
                  rules: [
                    {
                      required: true,
                      message: 'Enter cloud account name',
                    },
                    {
                      validator: this.validAccountName,
                    },
                  ],
                })(
                  <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                    <Input
                      value={this.props?.accountName}
                      placeholder={`E.g. ${this.props?.selectedCloud} Staging Account`}
                    />
                    <Tooltip title="Enter your cloud account name here">
                      <InfoCircleOutlined style={{ color: 'lightgrey', fontSize: '1.5rem' }} />
                    </Tooltip>
                  </div>
                )}
              </FormItem>
            </Form>
          </Col>
        </Row>
      </div>
    );
  }
}

export default AccountDetails;
